import { render, staticRenderFns } from "./BoletinesJudiciales.vue?vue&type=template&id=41e21516&lang=pug&"
import script from "./BoletinesJudiciales.vue?vue&type=script&lang=js&"
export * from "./BoletinesJudiciales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports